import { c as _c } from "react/compiler-runtime";
import { TabList } from '@headlessui/react';
import React from 'react';
import { twMerge } from 'tailwind-merge';
interface PageTabListProps extends Record<string, unknown> {
  className?: string;
  buttonBar?: React.ReactNode;
}
export const PageTabList = t0 => {
  const $ = _c(12);
  let buttonBar;
  let className;
  let props;
  if ($[0] !== t0) {
    ({
      className,
      buttonBar,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = buttonBar;
    $[2] = className;
    $[3] = props;
  } else {
    buttonBar = $[1];
    className = $[2];
    props = $[3];
  }
  let t1;
  if ($[4] !== className) {
    t1 = twMerge("bg-background-secondary mb-5 flex\n        w-screen  -translate-x-4 items-center justify-between px-0 \n        sm:-translate-x-6 \n        sm:px-6 md:-translate-x-14 md:px-14", className);
    $[4] = className;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[6] !== props) {
    t2 = <TabList className="hide-scrollbar flex overflow-scroll" {...props} />;
    $[6] = props;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== buttonBar || $[9] !== t1 || $[10] !== t2) {
    t3 = <div className={t1}>{t2}{buttonBar}</div>;
    $[8] = buttonBar;
    $[9] = t1;
    $[10] = t2;
    $[11] = t3;
  } else {
    t3 = $[11];
  }
  return t3;
};